import { PDFDocument, rgb } from "pdf-lib";
import { pdfImg, state } from "../settings";
import * as fontkit from "fontkit";
import $ from "jquery";
import { changeDimmensionRender, camera, CreateImageList, toggleBackWall, toggleLeftWall, toggleRightWall } from '../3d-configurator';

let pdfDimensionObjects = [];

export function cleanupPDFDimensions() {
  import('../3d-configurator').then(({ scene }) => {
    pdfDimensionObjects.forEach(dimensionGroup => {
      if (scene && dimensionGroup.parent) {
        scene.remove(dimensionGroup);
      }

      dimensionGroup.traverse((child) => {
        if (child.geometry) {
          child.geometry.dispose();
        }
        if (child.material) {
          if (child.material.map) child.material.map.dispose();
          child.material.dispose();
        }
      });
    });
    pdfDimensionObjects = [];
  }).catch(error => {
    console.log('Could not cleanup dimensions:', error);
  });
}

export async function createPDF() {

  const originalWallStates = {
    backWall: state.backWall,
    leftWall: state.leftWall,
    rightWall: state.rightWall
  };

  try {
    state.backWall = false;
    state.leftWall = false;
    state.rightWall = false;

    if (typeof toggleBackWall === 'function') toggleBackWall(false);
    if (typeof toggleLeftWall === 'function') toggleLeftWall(false);
    if (typeof toggleRightWall === 'function') toggleRightWall(false);

    await CreateImageList();

    const pdfDoc = await PDFDocument.create();
    const widthPage = 595;
    const heightPage = 842;
    const margin = 30;

    pdfDoc.registerFontkit(fontkit);

    const fontUrl = "./public/fonts/Poppins/Poppins-Medium.ttf";
    const fontBytes = await fetch(fontUrl).then((res) => res.arrayBuffer());
    const font = await pdfDoc.embedFont(fontBytes);

    const page1 = pdfDoc.addPage([widthPage, heightPage]);

    // PAGE 1
    const logoUrl = "./public/img/hide-away-logo.png";

    const logoImageBytes = await fetch(logoUrl).then((res) => res.arrayBuffer());
    const logoImage = await pdfDoc.embedPng(logoImageBytes);
    const pergolaImageBytes = await fetch(pdfImg.img).then((res) =>
      res.arrayBuffer()
    );

    const bwImageBytes = pergolaImageBytes;
    const bwImage = await pdfDoc.embedPng(bwImageBytes);

    const logoPhoneBytes = await fetch("./public/img/icons/phone.png").then((res) =>
      res.arrayBuffer()
    );
    const logoEarthBytes = await fetch("./public/img/icons/earth.png").then((res) =>
      res.arrayBuffer()
    );
    const logoMailBytes = await fetch("./public/img/icons/mail.png").then((res) =>
      res.arrayBuffer()
    );

    const logoPhone = await pdfDoc.embedPng(logoPhoneBytes);
    const logoEarth = await pdfDoc.embedPng(logoEarthBytes);
    const logoMail = await pdfDoc.embedPng(logoMailBytes);

    //#region Header
    const logoWidth = 246;
    const logoHeight = 89;

    page1.drawImage(logoImage, {
      x: (widthPage - logoWidth) / 2,
      y: heightPage - logoHeight,
      width: logoWidth,
      height: logoHeight,
    });

    const pergolaWidth = widthPage * 0.7;
    const perolaHeight = 215;

    page1.drawImage(bwImage, {
      x: (widthPage - pergolaWidth) / 2,
      y: heightPage - perolaHeight - logoHeight,
      width: pergolaWidth,
      height: perolaHeight,
    });
    //#endregion

    const fontSize = 12;
    const colorSecond = rgb(153 / 255, 122 / 255, 79 / 255);


    // first main list (Model, Wall, Roof, etc.)
    const mainListItems = $(".sum__page__main-list").first().find(".sum__page__main-list__item");

    const startY = heightPage - logoHeight - perolaHeight - margin;
    const lineHeight = 60;
    let currentY = startY;

    mainListItems.each((index, item) => {
      const title = $(item).find(".sum__page__main-list__item__title").text();
      const param = $(item).find(".sum__page__main-list__item__param").text();

      page1.drawText(title, {
        x: margin,
        y: currentY,
        size: fontSize,
        font: font,
        color: rgb(0, 0, 0),
      });

      const textWidth = font.widthOfTextAtSize(param, fontSize);
      page1.drawText(param, {
        x: widthPage - margin - textWidth,
        y: currentY,
        size: fontSize,
        font: font,
        color: colorSecond,
      });

      const underlineY = currentY - 26;
      page1.drawLine({
        start: { x: margin, y: underlineY },
        end: { x: widthPage - margin, y: underlineY },
        color: colorSecond,
        thickness: 1,
      });

      currentY -= lineHeight;
    });

    //#region Footer
    const phone = "+1 (587) 401-3007";
    const earth = "www.hideawayscreens.ca";
    const mail = "info@hideaway.inc";
    const textWidthPhone = font.widthOfTextAtSize(phone, fontSize);
    const textWidthEarth = font.widthOfTextAtSize(earth, fontSize);
    const textWidthMail = font.widthOfTextAtSize(mail, fontSize);

    const size = 10;

    const startYlogo = 20;
    const offsetY = 2;
    const offsetX = 5;

    page1.drawRectangle({
      x: 0,
      y: 0,
      width: widthPage,
      height: 55,
      color: colorSecond,
    });

    page1.drawImage(logoPhone, {
      x: margin,
      y: startYlogo,
      width: size,
      height: size,
    });

    page1.drawText(phone, {
      x: margin + size + offsetX, // Розташування тексту праворуч від іконки
      y: startYlogo + offsetY,
      size: size,
      font: font,
      color: rgb(1, 1, 1),
    });

    page1.drawImage(logoEarth, {
      x: widthPage / 2 - textWidthEarth / 2 - size - offsetX,
      y: startYlogo,
      width: size,
      height: size,
    });

    page1.drawText(earth, {
      x: (widthPage - textWidthEarth) / 2,
      y: startYlogo + offsetY,
      size: size,
      font: font,
      color: rgb(1, 1, 1),
    });

    // Малюємо пошту (mail)
    page1.drawImage(logoMail, {
      x: widthPage - textWidthMail - margin - size - offsetX,
      y: startYlogo,
      width: size,
      height: size,
    });

    page1.drawText(mail, {
      x: widthPage - textWidthMail - margin,
      y: startYlogo + offsetY,
      size: size,
      font: font,
      color: rgb(1, 1, 1),
    });

    //#endregion

    // PAGE 2
    const page2 = pdfDoc.addPage([widthPage, heightPage]);

    page2.drawImage(logoImage, {
      x: (widthPage - logoWidth) / 2,
      y: heightPage - logoHeight,
      width: logoWidth,
      height: logoHeight,
    });

    const fontTitle = 16;
    const titleFirst = "Electrical Options";
    const textTitleFirst = font.widthOfTextAtSize(titleFirst, fontTitle);
    const titleSecond = "Accessories";
    const textTitleSecond = font.widthOfTextAtSize(titleSecond, fontTitle);

    // "Electrical Options" 
    page2.drawText(titleFirst, {
      x: (widthPage - textTitleFirst) / 2,
      y: heightPage - logoHeight - margin * 2,
      size: fontTitle,
      font: font,
      color: rgb(0, 0, 0),
    });

    const electricalItems = $(".sum__page__electrical-options")
      .first()
      .find(".sum__page__main-list__item");

    const startYPage2 = heightPage - logoHeight - margin * 3;
    const lineHeightPage2 = 35;
    let currentYPage2 = startYPage2;

    electricalItems.each((index, item) => {
      const title = $(item).find(".sum__page__main-list__item__title").text();
      const param = $(item).find(".sum__page__main-list__item__param").text();

      let color = rgb(0, 0, 0);
      const colorSecond = rgb(153 / 255, 122 / 255, 79 / 255);

      if (title === "Spacing") {
        color = colorSecond;
      }

      page2.drawText(title, {
        x: margin,
        y: currentYPage2,
        size: fontSize,
        font: font,
        color: color,
      });

      const textWidth = font.widthOfTextAtSize(param, fontSize);
      page2.drawText(param, {
        x: widthPage - margin - textWidth,
        y: currentYPage2,
        size: fontSize,
        font: font,
        color: color,
      });

      currentYPage2 -= lineHeightPage2;
    });

    // Accessories items
    const accessoriesTitleY = currentYPage2 - margin;
    page2.drawText(titleSecond, {
      x: (widthPage - textTitleSecond) / 2,
      y: accessoriesTitleY,
      size: fontTitle,
      font: font,
      color: rgb(0, 0, 0),
    });

    const accessoriesItems = $(".sum__page__electrical-options")
      .last()
      .find(".sum__page__main-list__item");

    let currentYAccessories = accessoriesTitleY - margin;

    accessoriesItems.each((index, item) => {
      const title = $(item).find(".sum__page__main-list__item__title").text();
      const param = $(item).find(".sum__page__main-list__item__param").text();

      let color = rgb(0, 0, 0);
      const colorSecond = rgb(153 / 255, 122 / 255, 79 / 255);

      if (title === "Pattern" || title === "Color") {
        color = colorSecond;
      }

      page2.drawText(title, {
        x: margin,
        y: currentYAccessories,
        size: fontSize,
        font: font,
        color: color,
      });

      const textWidth = font.widthOfTextAtSize(param, fontSize);
      page2.drawText(param, {
        x: widthPage - margin - textWidth,
        y: currentYAccessories,
        size: fontSize,
        font: font,
        color: color,
      });

      currentYAccessories -= lineHeightPage2;
    });

    //#region Footer
    page2.drawRectangle({
      x: 0,
      y: 0,
      width: widthPage,
      height: 55,
      color: colorSecond,
    });

    page2.drawImage(logoPhone, {
      x: margin,
      y: startYlogo,
      width: size,
      height: size,
    });

    page2.drawText(phone, {
      x: margin + size + offsetX,
      y: startYlogo + offsetY,
      size: size,
      font: font,
      color: rgb(1, 1, 1),
    });

    page2.drawImage(logoEarth, {
      x: widthPage / 2 - textWidthEarth / 2 - size - offsetX,
      y: startYlogo,
      width: size,
      height: size,
    });

    page2.drawText(earth, {
      x: (widthPage - textWidthEarth) / 2,
      y: startYlogo + offsetY,
      size: size,
      font: font,
      color: rgb(1, 1, 1),
    });

    page2.drawImage(logoMail, {
      x: widthPage - textWidthMail - margin - size - offsetX,
      y: startYlogo,
      width: size,
      height: size,
    });

    page2.drawText(mail, {
      x: widthPage - textWidthMail - margin,
      y: startYlogo + offsetY,
      size: size,
      font: font,
      color: rgb(1, 1, 1),
    });


    const pdfBytes = await pdfDoc.save();
    const blob = new Blob([pdfBytes], { type: "application/pdf" });
    return blob;

  } finally {
    state.backWall = originalWallStates.backWall;
    state.leftWall = originalWallStates.leftWall;
    state.rightWall = originalWallStates.rightWall;

    if (originalWallStates.backWall) toggleBackWall(true);
    if (originalWallStates.leftWall) toggleLeftWall(true);
    if (originalWallStates.rightWall) toggleRightWall(true);
    //#endregion
  }
}

async function convertToBlackAndWhite(imageBytes) {
  return new Promise((resolve, reject) => {
    const canvas = document.createElement("canvas");
    const ctx = canvas.getContext("2d");

    const image = new Image();
    image.src = URL.createObjectURL(
      new Blob([imageBytes], { type: "image/png" })
    );

    image.onload = () => {
      canvas.width = image.width;
      canvas.height = image.height;

      ctx.drawImage(image, 0, 0);

      const imageData = ctx.getImageData(0, 0, canvas.width, canvas.height);
      const data = imageData.data;

      for (let i = 0; i < data.length; i += 4) {
        const r = data[i];
        const g = data[i + 1];
        const b = data[i + 2];

        const avg = (r + g + b) / 3;

        data[i] = data[i + 1] = data[i + 2] = avg;
      }

      ctx.putImageData(imageData, 0, 0);

      canvas.toBlob(async (blob) => {
        const bwImageBytes = await blob.arrayBuffer();
        resolve(bwImageBytes);
      }, "image/png");
    };

    image.onerror = reject;
  });
}
